export const initialState = () => ({
	rainfall: undefined,
	rainfallLoading: false,
	rainfallRetryCount: -1,
	activeSeries: []
});

export const rainfallLoading = () => ({
	rainfallLoading: true
});

export const rainfallLoadSuccess = data => ({
	rainfall: data,
	rainfallLoading: false,
	rainfallRetryCount: -1,
	activeSeries: [`${data.years[data.years.length - 1].year}`, 'average']
});

export const rainfallLoadFailure = currentRetryCount => ({
	rainfall: null,
	rainfallLoading: false,
	rainfallRetryCount: currentRetryCount + 1
});

export const removeActiveSeries = (currentActiveSeries, seriesName) => ({
	activeSeries: currentActiveSeries.filter(s => s !== seriesName)
});

export const addActiveSeries = (currentActiveSeries, seriesName) => ({
	activeSeries: currentActiveSeries.concat(seriesName)
});

export const setAllSeriesActive = data => ({
	activeSeries: data.years.map(d => `${d.year}`).concat('average')
});

export const setAllSeriesInactive = () => ({
	activeSeries: []
});



// WEBPACK FOOTER //
// ./routes/history-rainfall/reducers.js